
import {baseUrl} from './address';
// let baseUrl='/web/'
export const api = {
    
    /**
     * @deprecated Seller端 视图
     * @author hg <www.qingwuit.com>
     */

     // 用户中心
    "SellerCheckUserLogin" : baseUrl + "Seller/check_user_login", // 检测是否登录
    "sellerLogin" : baseUrl + "Seller/login", // 登录
    "sellerGetUserInfo" : baseUrl + "Seller/get_user_info", // 获取用户信息
    "sellerLogout" : baseUrl + "Seller/logout", // 退出登录
    "homeCommissionList":baseUrl+"user/invite_commission_list",//获取邀请奖励明细
    "sellerGetUsersList" : baseUrl + "Seller/users/index", // 获取用户列表
    "sellerEditUsers" : baseUrl + "Seller/users/edit/", // 获取用户列表
    "sellerGetInviterById" : baseUrl + "Seller/users/get_inviter_by_id", // 获取邀请用户列表
    "deliveryList": baseUrl + "user/deliveryList",//获取收件人列表      
    "addDeliveryInfo": baseUrl + "user/addDeliveryInfo",//增加和修改发货人
    //删除收货人
    "delDeliverInfo": baseUrl + "user/delDeliverInfo",
    //获取省市区
    "getAllAddress": baseUrl + "order/get_address_child",
    "homeDelFinanceRemark" : baseUrl + "user/del_finance_remark",  // 获取财务备注
    "centerSingleStorageInfo": baseUrl + "goods/goods_default_storage",


    //促销活动API
    'addPromotion':baseUrl+'Seller/config/addSubsiteSubsiteRecharge',
    'promotionList':baseUrl+'Seller/config/subsiteRechargeList',
    'someoneProInfo':baseUrl+'Seller/config/editSubsiteRecharge/',
    'deleProInfo':baseUrl+'Seller/config/delSubsiteRecharge',

    //仓储配置
    'storageList':baseUrl+'Seller/config/storageList',
    'editStorageFreight':baseUrl+'Seller/config/editSiteStorageFreight',

    // 订单管理
    "sellerGetOrderList" : baseUrl + "Seller/order/index", // 订单列表
    "sellerGetOrderInfo" : baseUrl + "Seller/order/info", // 订单详情
    "sellerGetOrderReceiptList" : baseUrl + "Seller/order/get_order_receipt_list", // 获取订单包裹信息
    "sellerGetOrderReceipt" : baseUrl + "Seller/order/get_order_receipt", // 获取所有订单包裹列表

    // 售后管理
    "sellerGetCheckPieces" : baseUrl + "Seller/after_sale/get_check_pieces", // 售后查件
    "sellerGetReceiveOrder" : baseUrl + "Seller/after_sale/get_receive_order", // 底单
    "getReceiveOrderList" : baseUrl + "user/check_pieces_list", //获取售后查件列表

    // 财务资金
    "sellerGetMoneyLog" : baseUrl + "Seller/money_log/index", // 支付日志
    "sellerGetOrderPay" : baseUrl + "Seller/order_pay/index", // 充值日志

    'sellerGetStatistics' : baseUrl + "Seller/index/get_statistics", // 统计
    'sellerGetStatisticsUser' : baseUrl + "Seller/index/get_statistics_user", // 统计
    'sellerGetStatisticsPrice' : baseUrl + "Seller/index/get_statistics_price", // 统计
    'sellerGetStatisticsReceipt' : baseUrl + "Seller/index/get_statistics_receipt", // 统计
    'sellerGetStatisticsOrder' : baseUrl + "Seller/index/get_statistics_order", // 统计
    'sellerGetStatisticsPay' : baseUrl + "Seller/index/get_statistics_pay", // 统计

    'sellerWebConfig' : baseUrl + "Seller/config/web_config", // 分站配置修改
    'sellerAlismsConfig' : baseUrl + "Seller/config/alisms_config", // 分站d短信配置修改
    'sellerConfigUpload' : baseUrl + "Seller/config/config_upload", // 配置上传文件
    'sellerCommissionList':baseUrl+"Seller/money_log/seller_invite_commission_list", //邀请奖励明细
    "sellerCommisionDetaills":baseUrl+"Seller/money_log/commission_list",//代理商佣金明细
        
    "getInviterReward": baseUrl + "mobile/invite_commission_list",//获取邀请奖励

    // 文章管理
    'sellerGetArticleList' : baseUrl + "Seller/article/index", // 
    'sellerAddArticle' : baseUrl + "Seller/article/add", // 
    'sellerEditArticle' : baseUrl + "Seller/article/edit/", // 
    'sellerDelArticle' : baseUrl + "Seller/article/del", // 

    // 单页管理
    'sellerGetPageList' : baseUrl + "Seller/pages/index", 
    'sellerEditPage' : baseUrl + "Seller/pages/edit/", 
    
    // 广告位
    'sellerGetetAdvPositionList' : baseUrl + "Seller/adv_position/index", 

    // 广告
    'sellerGetAdvList' : baseUrl + "Seller/adv/index", 
    'sellerAddAdv' : baseUrl + "Seller/adv/add",
    'sellerEditAdv' : baseUrl + "Seller/adv/edit/",
    'sellerDelAdv' : baseUrl + "Seller/adv/del",
    'sellerAdvUpload' : baseUrl + "Seller/adv/adv_upload", // 品牌图片上传

    'sellerAutoUpload' : baseUrl +"Seller/auto/auto_upload", // 内容编辑上传
    

    /**
     * @deprecated PC端 视图
     * @author hg <www.qingwuit.com>
     */

    // 用户登录注册
    "homeLogin" : baseUrl + "user/login", // 登录
    "homeLogout" : baseUrl + "user/logout", // 注销账号
    "homeGetOauthConfig" : baseUrl + "user/get_oauth_config", // 获取OAUTH
    "homeRegister" : baseUrl + "user/register", // 注册
    "homeForgetPassword" : baseUrl + "user/forget_password", // 忘记密码
    "homeSendSms" : baseUrl + "user/send_sms", // 发送短信
    "homeCheckUserLogin" : baseUrl + "check_user_login", // 检测是否登录
    "homeGetUserInfo" : baseUrl + "user/get_user_info", // 检测是否登录

    "homeGetUserInfoById" : baseUrl + "user/get_user_info_by_id", // 用户信息
    "homeGetInviterList" : baseUrl + "user/get_inviter_list", // 获取邀请人列表

    // 首页信息
    "homeGetIndexInfo" : baseUrl + "index/get_index_info", // 登录

    //提现
    "drawCash":baseUrl+"Seller/users/withdraw",
    "getFeePercent":baseUrl+"Seller/withdraw/getFee",
    "withDrawList":baseUrl+"Seller/withdraw/index",

    // 商品信息
    "homeGetGoodsInfo" : baseUrl + "goods/get_goods_info", // 获取商品详情
    "homeSearchGoods" : baseUrl + "goods/search_goods", // 搜索商品
    "homeSearchPurchaseGoods" : baseUrl + "goods/search_purchase_goods", // 搜索仓库商品
    "homeGetHistoryGoods" : baseUrl + "goods/get_history_goods", // 搜索仓库商品

    "homeGetWeightGroup" : baseUrl + "goods/get_weight_group", // 获取运费信息

    // 文章接口
    "homeGetArticleList" : baseUrl + "article/get_article_list", 
    "homeGetArticleInfo" : baseUrl + "article/get_article_info", 
    "homeGetArticleCatList" : baseUrl + "article/get_article_cat_list", 
    "homeReadArticle" : baseUrl + "article/read_article", 

    // 订单接口
    "homeCreateOrder" : baseUrl + "order/create_order",  // 创建订单
    "homeGetOrderList" : baseUrl + "order/get_order_list",  // 获取订单列表
    "homeGetOrderExcel" : baseUrl + "excel/download_excel",  // 导出订单列表
    "homeGetOrderInfo" : baseUrl + "order/get_order_info",  // 获取订单详情根据ID
    "homeGetGoogleAutoOrderInfo" : baseUrl + "order/get_google_auto_order_info",  // 获取插件自动发货的订单详情
    "homeThirdDeliverySend" : baseUrl + "order/third_delivery_send",  // 三方一键发货
    "homeThirdNewDeliverySend" : baseUrl + "order/new_third_delivery_send",  // 新三方一键发货
    "homeOrderListPay" : baseUrl + "order/order_list_pay",  // 订单列表支付
    "homeGetOrderReceiptList" : baseUrl + "order/get_order_receipt_list",  // 获取订单包裹列表
    "homeGetPreviewImage" : baseUrl + "order/get_preview_image",  // 获取底单信息

    // 修改订单和包裹状态接口
    "homeChangeOrderStatus" : baseUrl + "order/change_order_status", 
    "homeChangeReceiptStatus" : baseUrl + "order/change_receipt_status", 

    // 预购订单
    "homePurchaseCreateOrder" : baseUrl + "order/purchase_create_order",  // 创建预购订单
    "homeGetPurchaseList" : baseUrl + "order/get_purchase_list",  // 获取预购订单列表
    "homeGetPurchaseLog" : baseUrl + "order/get_purchase_log",  // 获取预购消耗记录

    // 入仓代发信息
    "homeAddSubstitute" : baseUrl + "user/add_substitute",  // 获取订单包裹列表

    // 单页信息
    "homeGetPagesInfo" : baseUrl + "user/pages",  // 获取订单包裹列表
    "homeGetSitePagesInfo" : baseUrl + "user/pages/site_info",  // 获取订单包裹列表
    "homeGetStorageList" : baseUrl + "api/user_storage_list",  // 会员中心仓库列表

    // 用户中心
    "homeGetUserDefult" : baseUrl + "user/get_user_default",  // 获取用户信息
    "homeGetMoneyLogList" : baseUrl + "user/get_money_log_list",  // 获取资金变动信息
    "homeEditUserInfo" : baseUrl + "user/edit_user_info",  // 获取资金变动信息
    "homeRecharge" : baseUrl + "user/recharge",  // 资金充值
    "homeCheckWxpayNative" : baseUrl + "user/check_wxpay_native",  // 验证是否支付成功接口
    "homeCheckYunpayNative" : baseUrl + "user/check_yunpay_native",  // 验证是否支付成功接口
    "homeDiscountInfo":baseUrl+'api/get_discount_info',
    "homeAddVip" : baseUrl + "user/add_vip",  // 成为VIP,
    //获取home支付列表
    "homePayList": baseUrl + "order/get_pay_msg",
    
    // 财务备注
    "homeAddFinanceRemark" : baseUrl + "user/add_finance_remark",  // 添加财务备注
    "homeGetFinanceRemark" : baseUrl + "user/get_finance_remark",  // 获取财务备注

    // 售后处理
    "homeAddCheckPieces" : baseUrl + "user/add_check_pieces",  // 售后查询
    "homeAddReceiveOrder" : baseUrl + "user/add_receive_order",  // 底单获取
    "homeCheckPiecesUpload" : baseUrl + "user/check_pieces_upload",  // 售后查询图片上传
    "homeGetReceiveOrder" : baseUrl + "user/get_receive_order",  // 底单获取记录
    "receiveOrderChange" : baseUrl + "Seller/after_sale/receive_order_change",  // 售后查询

    // excel 上传
    // 'homeAutoUpload' : baseUrl +"auto/auto_upload",
    'homeExcelUpload' : baseUrl +"excel/excel_upload",
    'homeExcelImport' : baseUrl +"excel/import_excel", // 导入excel 做筛选
    'homeExcelCheckStart' : baseUrl +"excel/check_excel_start", // 导入excel 验证
    'homeCheckHandleList' : baseUrl +"excel/check_handle_list", // 手动验证
    'EditAuthentication': baseUrl + "excel/is_authentication", // 修改实名认证 
    'HaveAuthentication': baseUrl + "user/obtain_authentication_results", // 获取实名认证信息
    'homeDownloadExcel' : baseUrl +"excel/download_excel", // excel下载
    
    
    'moneyLogDownloadExcel' : baseUrl + 'user/excel_money_log',//前台excel导出
    'commissionDownloadExcel' : baseUrl + "user/excel_invite_commission", //前台资金列表导出
    'packetExportExcel' : baseUrl + "Seller/order/receipt_excel_download",//后台包裹列表导出
    'getSubsiteData': baseUrl + "Admin/order_pay/seach_data", //获取分站信息
    'moneyLogExportExcel': baseUrl + "Seller/money_log/excel_money_log",//后台资金列表导出
    "editSaleReply" : baseUrl + "Seller/after_sale/change_check_pieces/",
    "saleReplyUpload" : baseUrl + "Seller/after_sale/upload_reply",//售后查件反馈照片
    "adminBatchPrintOrder" : baseUrl + "Admin/order/batch_print",  // 批量设置发货
    "changeOrderStatus" : baseUrl + "Admin/order/change_status",  // 修改订单状态
    'delUsers' : baseUrl + "Admin/users/del",
    'editOrderPay' : baseUrl + "Admin/order_pay/edit",
    'receiptRepeat' : baseUrl + "api/get_receipt_repeat",
    "changOrderReceiptStatus" : baseUrl + "Admin/order/change_receipt_status",  // 修改订单包裹发货状态
    
    /**
     * 公共接口
     * @author hg <www.qingwuit.com>
     */

    // 获取协议数据(根据ename)
    "homeGetAgreementInfo" : baseUrl + "api/get_agreement_info",

    // 获取省市区信息
    "homeGetAreaList" : baseUrl + "api/get_area_list",

    // 获取PC商品分类信息
    "homeGetGoodsClassList" : baseUrl + "api/get_goods_class_list",

    // 获取PC 幻灯片或者广告
    "homeGetBanner" : baseUrl + "api/get_banner",

    // 获取库存信息
    "homeGetStorageInfo" : baseUrl + "api/get_storage_info",
    "centerGetStorageInfo" : baseUrl + "api/get_Storage_Name",
    
    "homeGetVipGroups" : baseUrl + "user/get_type_list", // 获取用户组类型(升级会员时用)
    "getStoragesWeightGroup" : baseUrl + "Admin/weight/get_weight_group", // 获取运费重量组列表
    
    //获取仓储运费
    "getSitestorageInfo":baseUrl+"api/get_sitestorage_info",

    // 获取快递信息
    "getExpressInfo" : baseUrl + "api/get_express_info",

    // 获取配置信息
    // "getConfigInfo" : baseUrl + "api/get_config_info",
    "getConfigInfo" : baseUrl + "mobile/get_config_info",

    // 获取网址配置信息
    "getSubsiteConfigInfo" : baseUrl + "api/get_subsite_config_info",

   //余额预警
   "balanceRemind":baseUrl+"Seller/user/balanceReminder",
 
    //邀请人提成
    "addSubsiteRoyalty":baseUrl+"Seller/config/add_subsite_royalty",

   //模板配色
   "templateColorList":baseUrl+"Seller/config/color_template_list",//模板列表
   "setAdminTemplateColor":baseUrl+"Seller/config/set_site_color_template",//设置分站模板颜色

   //意见反馈
   "suggestFeedBack": baseUrl+'mobile/add_user_views', //意见反馈

    // 仓库停发地列表
    "getForbidAreaList" : baseUrl + "excel/forbid_area_list",

    // 校验停发区域
    "getCheckForbidArea" : baseUrl + "excel/check_forbid_area",


    'adminGetStatisticsUserAnalysis': baseUrl + "Seller/index/site_user_analysis",  //用户分析
    'adminGetStatisticsReceiptAnalysis': baseUrl + "Seller/index/site_receipt_analysis", //包裹分析
    'adminGetStatisticsRechargeAnalysis': baseUrl + "Seller/index/site_recharge_analysis", //充值分析
    'adminGetStatisticsOrderAnalysis': baseUrl + "Seller/index/site_order_analysis", //订单分析
    'adminGetStatisticsRevenueAnalysis': baseUrl + "Seller/index/site_revenue_analysis", //营收分析

    // 拼多多打单
    'homePddPrintsChecktimeout': baseUrl +"user/add_user_shop", // 用户是否到期
    'homePddUserShops': baseUrl +"user/user_shops", // 获取用户关联店铺列表
    'homePddCheckUserShop': baseUrl +"user/check_user_shop", // 检验店铺是否可用
    'homePddDelUserShop': baseUrl +"user/del_user_shop", // 删除用户关联店铺
    'homeGetPddOrderList': baseUrl +"order/synchronization_order_list", // 用户获取订单
    'homeCreatSynchronizationOrder': baseUrl +"order/creat_synchronization_order", // 创建拼多多订单

    // 淘宝打单助手
    'homeTaobaoAddUserShop': baseUrl +"user/add_tb_shop", // 添加用户关联店铺
    'homeTaobaoGetUserShops': baseUrl +"user/user_tb_shops", // 获取用户关联店铺列表
    'homeTaobaoDelUserShops': baseUrl +"user/del_tb_shop", // 删除用户关联店铺
    'homeTaobaoCheckUserShops': baseUrl +"user/check_tb_shop", // 检验店铺是否可用
    'homeTaobaoSynchronousList': baseUrl +"order/synchronous_tb_list", // 同步淘宝订单
    'homeTaobaoCreateOrder': baseUrl +"order/create_tb_order", // 淘宝同步订单下单

    'homeTbGetAuthUrl': baseUrl +"user/get_tb_auth_url", // 淘宝同步订单下单
    'homeTbSyncShopOrder': baseUrl +"order/synchronous_tb_list_sdkd", // 淘宝同步订单
    'homeTbAddAuthShop': baseUrl +"user/add_tb_shop_sdkd", // 淘宝state绑定店铺
    'homeTbGetAuthShop': baseUrl +"user/get_tb_shop_sdkd", // 获取淘宝绑定店铺信息
    'homeTbDelAuthShop': baseUrl +"user/del_tb_shop_sdkd", // 删除淘宝绑定店铺信息
    'homeTbCheckAuthShop': baseUrl +"user/check_tb_shop_sdkd", // 检查店铺是否过期

    // 抖音店铺打单助手
    'homeDouyinAddUserShop': baseUrl +"user/add_dy_shop", // 添加用户关联店铺
    'homeDouyinGetUserShops': baseUrl +"user/get_dy_shop_sdkd", // 获取用户关联店铺列表
    'homeDouyinDelUserShops': baseUrl +"user/del_dy_shop_sdkd", // 删除用户关联店铺
    'homeDouyinCheckUserShops': baseUrl +"user/check_dy_shop_sdkd", // 检验店铺是否可用
    'homeDouyinSynchronousList': baseUrl +"order/synchronous_dy_list_sdkd", // 同步淘宝订单
    'homeDouyinCreateOrder': baseUrl +"order/create_dy_order", // 抖音同步订单下单
    'homeDouyinRefreshOrder': baseUrl +"Storage/order/refresh_dy_print_info_list", // 刷新抖音打印信息
    'homeDouyinGetOauthState': baseUrl +"user/get_dy_auth_url", // 获取抖音授权state
    'homeDouyinAddShopByState': baseUrl +"user/add_dy_shop_sdkd", // 通过state添加店铺

    // 授权店铺列表
    "getUserAuthShop": baseUrl +"user/auth_shop",
    // 关联码授权店铺
    "bindShopAssociationCode": baseUrl +"user/add_bind",
    // 获取订单下的包裹号
    "getOrderAllReceipt": baseUrl +"order/get_order_receipt_nos",
    // 新一键发货
    "newDeliverySend": baseUrl +"order/new_delivery_send",
}